import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";

interface IntegrationLogo {
  src: string;
  bg: string;
  imgClassName: string;
}

export const INTEGRATION_LOGO: Partial<Record<IntegrationId, IntegrationLogo>> =
  {
    [IntegrationId.CODEBOX]: {
      src: "/assets/codebox_logo.png",
      bg: "#007CCE",
      imgClassName: "w-[33px] h-[5px]"
    },
    [IntegrationId.ZILLOW]: {
      src: "/assets/zillow_logo.png",
      bg: "transparent",
      imgClassName: "w-full h-full rounded-lg"
    }
  };
